import { FC, useContext } from 'react';

import { ResumeCardActionsContext } from 'src/components/ResumeCard/Actions/Context';
import { useVacancyId } from 'src/components/ResumeCard/hooks/useVacancyId';
import Comments from 'src/components/ResumeComments';

import Comment from 'src/components/ResumeCard/Actions/Comments/Comment';

const renderComments = {
    item: Comment,
};

const CommentsContainer: FC = () => {
    const { resume, commentToggle } = useContext(ResumeCardActionsContext);
    const [showComments] = commentToggle;
    const vacancyId = useVacancyId();

    if (!showComments) {
        return null;
    }

    return (
        <Comments
            user={Number(resume._attributes.user)}
            render={renderComments}
            topicId={resume.topicId}
            resumeHash={resume._attributes.hash}
            vacancyId={vacancyId?.toString()}
            addFromCard
        />
    );
};

export default CommentsContainer;
